import { useState, useEffect } from 'react';
import api from '../services/api';

interface FormData {
  name: string; company: string; email: string; country: string; website: string;
  password: string; confirmPassword: string;
  channelWebpage: string; channelLinkedin: string; channelTwitter: string;
  channelInstagram: string; channelYoutube: string; channelTiktok: string;
  channelOther: string; showOther: boolean;
  partnerType: string; niches: string[];
  promotionMethods: string[]; promotionDescription: string;
  estimatedReferrals: string; howDidYouHear: string;
  regions: string[]; previousPrograms: string;
  acceptedNoFraud: boolean; acceptedNoGuarantee: boolean; acceptedTerms: boolean;
  website_url: string;
  showPassword: boolean; showConfirmPassword: boolean;
}

const COUNTRIES = [
  'España','México','Argentina','Colombia','Chile','Perú','Venezuela','Ecuador',
  'Bolivia','Paraguay','Uruguay','Guatemala','Honduras','El Salvador','Nicaragua',
  'Costa Rica','Panamá','Cuba','República Dominicana','Puerto Rico',
  'Estados Unidos','Canadá','Brasil','Portugal','Francia','Alemania',
  'Reino Unido','Italia','Países Bajos','Bélgica','Suiza','Suecia',
  'Noruega','Dinamarca','Finlandia','Polonia','Australia','Nueva Zelanda',
  'Japón','China','India','Otro',
];

const NICHES = [
  'SEO','Marketing Digital','E-commerce','SaaS','B2B','Growth','Fintech',
  'Startups','Desarrollo Web','Relaciones Públicas','Content Marketing',
  'Publicidad/PPC','Diseño/UX','Real Estate','Salud/Wellness',
  'Educación','Legal/Consultoría','Travel/Turismo','Otro',
];

const PROMOTION_METHODS = [
  'Recomendación a clientes','Artículos/Reviews en blog','Redes sociales',
  'Newsletter/Email','Videos/Podcast','Integración SaaS',
  'Comunidad privada','Eventos/Webinars','Otro',
];

const REGIONS = [
  'España','México','Argentina','Colombia','Chile',
  'Resto Latam','US Hispano','US Inglés','Europa','Global',
];

const PARTNER_TYPES = [
  'Agencia SEO / Marketing','Consultor / Freelancer','Creador de contenido',
  'Influencer B2B / LinkedIn','Herramienta SaaS','Otro',
];

const base = 'w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white placeholder-gray-500 focus:outline-none focus:border-violet-500 transition-all text-sm';
const lbl = 'block text-sm font-medium text-white mb-1.5';
const errCls = 'text-red-400 text-xs mt-1';

// ── SVG Icons ──────────────────────────────────────────────────────────────
const IconGlobe = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
);
const IconLinkedin = () => (
  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);
const IconTwitterX = () => (
  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
  </svg>
);
const IconInstagram = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" strokeWidth={1.8}/>
    <circle cx="12" cy="12" r="4" strokeWidth={1.8}/>
    <circle cx="17.5" cy="6.5" r="0.5" fill="currentColor"/>
  </svg>
);
const IconYoutube = () => (
  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
    <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
  </svg>
);
const IconTiktok = () => (
  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
    <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.69a8.28 8.28 0 004.84 1.54V6.78a4.85 4.85 0 01-1.07-.09z"/>
  </svg>
);
const IconPlus = () => (
  <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M12 4v16m8-8H4"/>
  </svg>
);
const IconMinus = () => (
  <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M4 12h16"/>
  </svg>
);
const IconCheck = ({ className = 'w-3 h-3' }: { className?: string }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7"/>
  </svg>
);
const IconSend = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"/>
  </svg>
);
const IconDollar = () => (
  <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
  </svg>
);
const IconBolt = () => (
  <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z"/>
  </svg>
);
const IconClock = () => (
  <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
  </svg>
);
const IconCheckCircle = () => (
  <svg className="w-9 h-9 text-emerald-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7"/>
  </svg>
);

// ── Sub-components ─────────────────────────────────────────────────────────
function Pill({ text, active, onClick }: { text: string; active: boolean; onClick: () => void }) {
  return (
    <button type="button" onClick={onClick}
      className={`px-3 py-1.5 rounded-full text-sm font-medium border transition-all ${
        active
          ? 'bg-violet-600/30 border-violet-500 text-violet-300'
          : 'bg-white/5 border-white/10 text-gray-400 hover:border-white/25'
      }`}>
      {text}
    </button>
  );
}

function StepIcon({ n }: { n: number }) {
  return (
    <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-violet-600 to-violet-400 flex items-center justify-center text-white font-bold text-sm flex-shrink-0">
      {n}
    </div>
  );
}

// ── Main component ─────────────────────────────────────────────────────────
export default function Register() {
  const [step, setStep] = useState(1);
  const [done, setDone] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState('');
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [referralKey, setReferralKey] = useState('');
  const [referrerName, setReferrerName] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get('ref');
    if (!ref) return;
    setReferralKey(ref);
    upd('howDidYouHear', 'Recomendación');
    api.get(`/partners/referrer?ref=${encodeURIComponent(ref)}`)
      .then((res: { data: { name: string | null } }) => { if (res.data.name) setReferrerName(res.data.name); })
      .catch(() => {});
  }, []);

  const [form, setForm] = useState<FormData>({
    name: '', company: '', email: '', country: '', website: '',
    password: '', confirmPassword: '',
    channelWebpage: '', channelLinkedin: '', channelTwitter: '',
    channelInstagram: '', channelYoutube: '', channelTiktok: '',
    channelOther: '', showOther: false,
    partnerType: '', niches: [],
    promotionMethods: [], promotionDescription: '',
    estimatedReferrals: '', howDidYouHear: '',
    regions: [], previousPrograms: '',
    acceptedNoFraud: false, acceptedNoGuarantee: false, acceptedTerms: false,
    website_url: '',
    showPassword: false, showConfirmPassword: false,
  });

  const upd = (field: keyof FormData, value: unknown) => {
    setForm(p => ({ ...p, [field]: value }));
    setErrors(p => ({ ...p, [field]: '' }));
  };

  const toggle = (field: 'niches' | 'promotionMethods' | 'regions', val: string) => {
    setForm(p => {
      const arr = p[field] as string[];
      return { ...p, [field]: arr.includes(val) ? arr.filter(x => x !== val) : [...arr, val] };
    });
  };

  const channelCount = [
    form.channelWebpage, form.channelLinkedin, form.channelTwitter,
    form.channelInstagram, form.channelYoutube, form.channelTiktok, form.channelOther,
  ].filter(Boolean).length;

  const validate = (): boolean => {
    const e: Record<string, string> = {};
    if (step === 1) {
      if (form.name.trim().length < 2) e.name = 'Nombre requerido (mín. 2 caracteres)';
      if (!form.company.trim()) e.company = 'Empresa o marca requerida';
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) e.email = 'Email válido requerido';
      if (!form.country) e.country = 'País requerido';
      if (form.password.length < 8) e.password = 'Contraseña requerida (mín. 8 caracteres)';
      if (form.confirmPassword !== form.password) e.confirmPassword = 'Las contraseñas no coinciden';
    }
    if (step === 2 && channelCount < 1) e.channels = 'Agrega al menos 1 canal activo';
    if (step === 3) {
      if (!form.partnerType) e.partnerType = 'Selecciona el tipo de partner';
      if (!form.niches.length) e.niches = 'Selecciona al menos 1 nicho';
    }
    if (step === 4) {
      if (!form.promotionMethods.length) e.promotionMethods = 'Selecciona al menos 1 método';
      if (form.promotionDescription.trim().length < 10) e.promotionDescription = 'Descripción requerida (mín. 10 caracteres)';
      if (!form.estimatedReferrals) e.estimatedReferrals = 'Selecciona un rango';
    }
    if (step === 5) {
      if (!form.regions.length) e.regions = 'Selecciona al menos 1 región';
      if (!form.previousPrograms) e.previousPrograms = 'Selecciona una opción';
    }
    if (step === 6) {
      if (!form.acceptedNoFraud) e.acceptedNoFraud = 'Requerido';
      if (!form.acceptedNoGuarantee) e.acceptedNoGuarantee = 'Requerido';
      if (!form.acceptedTerms) e.acceptedTerms = 'Requerido';
    }
    setErrors(e);
    return !Object.keys(e).length;
  };

  const next = () => { if (validate()) setStep(s => s + 1); };
  const back = () => { setErrors({}); setStep(s => s - 1); };

  const submit = async () => {
    if (!validate()) return;
    setSubmitting(true);
    setSubmitError('');
    try {
      await api.post('/partners/apply', {
        website_url: form.website_url,
        referralKey: referralKey || undefined,
        name: form.name, company: form.company, email: form.email,
        password: form.password,
        country: form.country, website: form.website || undefined,
        channelWebpage: form.channelWebpage || undefined,
        channelLinkedin: form.channelLinkedin || undefined,
        channelTwitter: form.channelTwitter || undefined,
        channelInstagram: form.channelInstagram || undefined,
        channelYoutube: form.channelYoutube || undefined,
        channelTiktok: form.channelTiktok || undefined,
        channelOther: form.channelOther || undefined,
        partnerType: form.partnerType, niches: form.niches,
        promotionMethods: form.promotionMethods,
        promotionDescription: form.promotionDescription,
        estimatedReferrals: form.estimatedReferrals,
        howDidYouHear: form.howDidYouHear || undefined,
        regions: form.regions, previousPrograms: form.previousPrograms,
        acceptedPolicies: true,
      });
      setDone(true);
    } catch (e: unknown) {
      setSubmitError((e as Error).message || 'Error al enviar. Intenta de nuevo.');
    } finally {
      setSubmitting(false);
    }
  };

  const Progress = () => (
    <div className="space-y-2">
      <div className="flex gap-1.5">
        {[1,2,3,4,5,6].map(i => (
          <div key={i} className={`flex-1 h-1.5 rounded-full transition-all duration-500 ${
            i <= step ? 'bg-gradient-to-r from-violet-600 to-violet-400' : 'bg-white/10'
          }`} />
        ))}
      </div>
      <p className="text-xs text-gray-500 text-right">Paso {step} de 6</p>
    </div>
  );

  const Nav = ({ onNext, label = 'Continuar', isSubmit = false }: { onNext: () => void; label?: string; isSubmit?: boolean }) => (
    <div className="flex gap-3 mt-8">
      {step > 1 && (
        <button type="button" onClick={back}
          className="flex-1 px-4 py-3 rounded-xl bg-white/5 border border-white/10 text-gray-300 font-medium hover:bg-white/10 transition-all text-sm flex items-center justify-center gap-2">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7"/>
          </svg>
          Atrás
        </button>
      )}
      <button type="button" onClick={onNext} disabled={isSubmit && submitting}
        className="flex-1 px-4 py-3 rounded-xl bg-gradient-to-r from-violet-600 to-violet-400 text-white font-semibold hover:opacity-90 transition-all text-sm disabled:opacity-50 flex items-center justify-center gap-2">
        {isSubmit ? <IconSend /> : null}
        {isSubmit && submitting ? 'Enviando...' : label}
        {!isSubmit && (
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7"/>
          </svg>
        )}
      </button>
    </div>
  );

  // ── Done screen ───────────────────────────────────────────────────────────
  if (done) {
    return (
      <div className="min-h-screen bg-[#0a0a0f] flex items-center justify-center p-4">
        <div className="max-w-md w-full text-center space-y-5 animate-fade-in">
          <div className="w-20 h-20 rounded-full bg-emerald-500/15 border-2 border-emerald-400/60 flex items-center justify-center mx-auto">
            <IconCheckCircle />
          </div>
          <h1 className="text-3xl font-bold text-white">Solicitud recibida</h1>
          <p className="text-gray-300 text-base">Tu solicitud ha sido enviada correctamente y está pendiente de revisión por nuestro equipo.</p>
          <span className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-violet-500/15 border border-violet-400/40 text-violet-300 text-sm font-semibold">
            <IconClock />
            En revisión
          </span>
          <p className="text-gray-500 text-sm">Recibirás un email de confirmación una vez que tu solicitud sea aprobada. El proceso puede tomar hasta 48 horas.</p>
          <a href="/login" className="inline-flex items-center gap-1.5 text-violet-400 hover:text-violet-300 text-sm transition-colors mt-2">
            Ir al inicio de sesión
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7"/>
            </svg>
          </a>
        </div>
      </div>
    );
  }

  // ── Wizard ────────────────────────────────────────────────────────────────
  return (
    <div className="min-h-screen bg-[#0a0a0f] flex items-center justify-center p-4 py-12">
      <div className="w-full max-w-xl">

        {/* Header */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2.5 mb-5">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-violet-600 to-violet-400 flex items-center justify-center shadow-lg">
              <IconGlobe />
            </div>
            <span className="text-2xl font-bold text-white tracking-tight">
              World<span className="text-violet-400">Reach</span>
            </span>
          </div>
          <h1 className="text-3xl font-bold bg-gradient-to-r from-violet-300 to-violet-100 bg-clip-text text-transparent mb-3">
            Programa de Partners
          </h1>
          {referrerName && (
            <p className="text-sm text-gray-400 mb-3">
              Referido por <span className="text-violet-300 font-semibold">{referrerName}</span>
            </p>
          )}
          <div className="flex flex-wrap justify-center gap-2">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-white/5 border border-white/10 text-gray-300 text-xs font-medium">
              <IconDollar /> 100% gratuito
            </span>
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-white/5 border border-white/10 text-gray-300 text-xs font-medium">
              <IconBolt /> Comisiones recurrentes
            </span>
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-white/5 border border-white/10 text-gray-300 text-xs font-medium">
              <IconClock /> Aprobación en 48h
            </span>
          </div>
        </div>

        {/* Card */}
        <div className="bg-[#0f0f1a] border border-white/10 rounded-2xl p-6 shadow-2xl">
          <Progress />

          <div className="mt-7">

            {/* ── PASO 1 ── */}
            {step === 1 && (
              <div className="animate-fade-in">
                <div className="flex items-start gap-3 mb-6">
                  <StepIcon n={1} />
                  <div>
                    <h2 className="text-xl font-bold text-white">Datos básicos</h2>
                    <p className="text-sm text-gray-400 mt-0.5">Cuéntanos sobre ti y tu proyecto.</p>
                  </div>
                </div>
                <div className="space-y-4">
                  <div>
                    <label className={lbl}>Nombre completo *</label>
                    <input className={base} placeholder="Tu nombre completo" value={form.name} onChange={e => upd('name', e.target.value)} />
                    {errors.name && <p className={errCls}>{errors.name}</p>}
                  </div>
                  <div>
                    <label className={lbl}>Empresa o marca personal *</label>
                    <input className={base} placeholder="Nombre de tu empresa o marca" value={form.company} onChange={e => upd('company', e.target.value)} />
                    {errors.company && <p className={errCls}>{errors.company}</p>}
                  </div>
                  <div>
                    <label className={lbl}>Email *</label>
                    <input type="email" className={base} placeholder="tu@email.com" value={form.email} onChange={e => upd('email', e.target.value)} />
                    {errors.email && <p className={errCls}>{errors.email}</p>}
                  </div>
                  <div>
                    <label className={lbl}>País de operación *</label>
                    <select className={`${base} bg-[#0f0f1a]`} value={form.country} onChange={e => upd('country', e.target.value)}>
                      <option value="">Selecciona tu país...</option>
                      {COUNTRIES.map(c => <option key={c} value={c}>{c}</option>)}
                    </select>
                    {errors.country && <p className={errCls}>{errors.country}</p>}
                  </div>
                  <div>
                    <label className={lbl}>Contraseña *</label>
                    <div className="relative">
                      <input
                        type={form.showPassword ? 'text' : 'password'}
                        className={`${base} pr-10`}
                        placeholder="Mínimo 8 caracteres"
                        value={form.password}
                        onChange={e => upd('password', e.target.value)}
                      />
                      <button type="button" onClick={() => upd('showPassword', !form.showPassword)}
                        className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-300 transition-colors">
                        {form.showPassword
                          ? <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"/></svg>
                          : <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/></svg>
                        }
                      </button>
                    </div>
                    {errors.password && <p className={errCls}>{errors.password}</p>}
                  </div>
                  <div>
                    <label className={lbl}>Confirmar contraseña *</label>
                    <div className="relative">
                      <input
                        type={form.showConfirmPassword ? 'text' : 'password'}
                        className={`${base} pr-10`}
                        placeholder="Repite tu contraseña"
                        value={form.confirmPassword}
                        onChange={e => upd('confirmPassword', e.target.value)}
                      />
                      <button type="button" onClick={() => upd('showConfirmPassword', !form.showConfirmPassword)}
                        className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-300 transition-colors">
                        {form.showConfirmPassword
                          ? <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"/></svg>
                          : <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/></svg>
                        }
                      </button>
                    </div>
                    {errors.confirmPassword && <p className={errCls}>{errors.confirmPassword}</p>}
                  </div>
                  <div>
                    <label className={lbl}>Sitio web <span className="text-gray-500 font-normal">(opcional)</span></label>
                    <input type="url" className={base} placeholder="https://tusitio.com" value={form.website} onChange={e => upd('website', e.target.value)} />
                  </div>
                  <input type="text" name="website_url" value={form.website_url} onChange={e => upd('website_url', e.target.value)} className="hidden" tabIndex={-1} autoComplete="off" />
                </div>
                <Nav onNext={next} />
              </div>
            )}

            {/* ── PASO 2 ── */}
            {step === 2 && (
              <div className="animate-fade-in">
                <div className="flex items-start gap-3 mb-6">
                  <StepIcon n={2} />
                  <div>
                    <h2 className="text-xl font-bold text-white">Estrategia de referidos</h2>
                    <p className="text-sm text-gray-400 mt-0.5">Agrega al menos 1 canal activo. Más canales = aprobación más rápida.</p>
                  </div>
                </div>
                <div className="flex items-center justify-between mb-4 px-1">
                  <span className="text-sm text-gray-400">Canales conectados:</span>
                  <span className={`text-sm font-bold ${channelCount >= 1 ? 'text-violet-400' : 'text-gray-600'}`}>{channelCount} de 7</span>
                </div>
                {errors.channels && <p className={`${errCls} mb-3`}>{errors.channels}</p>}
                <div className="space-y-3">
                  {([
                    { key: 'channelWebpage',   Icon: IconGlobe,     ph: 'https://tupagina.com' },
                    { key: 'channelLinkedin',  Icon: IconLinkedin,  ph: 'linkedin.com/in/tu-perfil' },
                    { key: 'channelTwitter',   Icon: IconTwitterX,  ph: '@usuario' },
                    { key: 'channelInstagram', Icon: IconInstagram, ph: '@usuario' },
                    { key: 'channelYoutube',   Icon: IconYoutube,   ph: 'youtube.com/c/tu-canal' },
                    { key: 'channelTiktok',    Icon: IconTiktok,    ph: '@usuario' },
                  ] as const).map(({ key, Icon, ph }) => (
                    <div key={key} className="flex items-center gap-3">
                      <span className="text-gray-400 w-5 flex-shrink-0 flex justify-center"><Icon /></span>
                      <input
                        className={`${base} flex-1`}
                        placeholder={ph}
                        value={(form as unknown as Record<string, string>)[key]}
                        onChange={e => upd(key as keyof FormData, e.target.value)}
                      />
                    </div>
                  ))}
                  <div>
                    <button type="button" onClick={() => upd('showOther', !form.showOther)}
                      className="flex items-center gap-2 text-sm text-violet-400 hover:text-violet-300 transition-colors mt-1">
                      <span className="w-5 h-5 rounded-full border border-violet-500 flex items-center justify-center">
                        {form.showOther ? <IconMinus /> : <IconPlus />}
                      </span>
                      Otro canal
                    </button>
                    {form.showOther && (
                      <textarea className={`${base} mt-2`} rows={2} placeholder="Describe tu otro canal..." value={form.channelOther} onChange={e => upd('channelOther', e.target.value)} />
                    )}
                  </div>
                </div>
                <Nav onNext={next} />
              </div>
            )}

            {/* ── PASO 3 ── */}
            {step === 3 && (
              <div className="animate-fade-in">
                <div className="flex items-start gap-3 mb-6">
                  <StepIcon n={3} />
                  <div>
                    <h2 className="text-xl font-bold text-white">Tu perfil</h2>
                    <p className="text-sm text-gray-400 mt-0.5">Define tu tipo de negocio y nicho principal.</p>
                  </div>
                </div>
                <div className="space-y-6">
                  <div>
                    <label className={lbl}>¿Qué tipo de partner eres? *</label>
                    {errors.partnerType && <p className={errCls}>{errors.partnerType}</p>}
                    <div className="grid grid-cols-2 gap-2 mt-2">
                      {PARTNER_TYPES.map(pt => (
                        <button key={pt} type="button" onClick={() => upd('partnerType', pt)}
                          className={`p-3 rounded-xl border text-sm font-medium text-left transition-all ${
                            form.partnerType === pt
                              ? 'bg-violet-600/30 border-violet-500 text-violet-300'
                              : 'bg-white/5 border-white/10 text-gray-400 hover:border-white/25'
                          }`}>
                          {pt}
                        </button>
                      ))}
                    </div>
                  </div>
                  <div>
                    <label className={lbl}>Nicho o temática principal * <span className="text-gray-500 font-normal">(selecciona varios)</span></label>
                    {errors.niches && <p className={errCls}>{errors.niches}</p>}
                    <div className="flex flex-wrap gap-2 mt-2">
                      {NICHES.map(n => <Pill key={n} text={n} active={form.niches.includes(n)} onClick={() => toggle('niches', n)} />)}
                    </div>
                  </div>
                </div>
                <Nav onNext={next} />
              </div>
            )}

            {/* ── PASO 4 ── */}
            {step === 4 && (
              <div className="animate-fade-in">
                <div className="flex items-start gap-3 mb-6">
                  <StepIcon n={4} />
                  <div>
                    <h2 className="text-xl font-bold text-white">Plan de promoción</h2>
                    <p className="text-sm text-gray-400 mt-0.5">¿Cómo vas a llevar tráfico y clientes a WorldReach?</p>
                  </div>
                </div>
                <div className="space-y-5">
                  <div>
                    <label className={lbl}>¿Cómo vas a promocionarnos? * <span className="text-gray-500 font-normal">(selecciona varios)</span></label>
                    {errors.promotionMethods && <p className={errCls}>{errors.promotionMethods}</p>}
                    <div className="flex flex-wrap gap-2 mt-2">
                      {PROMOTION_METHODS.map(m => <Pill key={m} text={m} active={form.promotionMethods.includes(m)} onClick={() => toggle('promotionMethods', m)} />)}
                    </div>
                  </div>
                  <div>
                    <label className={lbl}>¿Cómo encaja WorldReach con lo que ya haces? *</label>
                    <textarea className={base} rows={4} maxLength={500} placeholder="Describe cómo encaja WorldReach en tu estrategia actual..." value={form.promotionDescription} onChange={e => upd('promotionDescription', e.target.value)} />
                    <div className="flex justify-between mt-1">
                      {errors.promotionDescription ? <p className={errCls}>{errors.promotionDescription}</p> : <span />}
                      <span className="text-gray-600 text-xs">{form.promotionDescription.length}/500</span>
                    </div>
                  </div>
                  <div>
                    <label className={lbl}>Referidos estimados / mes *</label>
                    <select className={`${base} bg-[#0f0f1a]`} value={form.estimatedReferrals} onChange={e => upd('estimatedReferrals', e.target.value)}>
                      <option value="">Selecciona un rango...</option>
                      {['1-3','4-10','11-25','26-50','50+'].map(r => <option key={r} value={r}>{r}</option>)}
                    </select>
                    {errors.estimatedReferrals && <p className={errCls}>{errors.estimatedReferrals}</p>}
                  </div>
                  <div>
                    <label className={lbl}>¿Cómo nos conociste? <span className="text-gray-500 font-normal">(opcional)</span></label>
                    {referralKey ? (
                      <div className={`${base} flex items-center gap-2 opacity-70 cursor-not-allowed`}>
                        <span>Recomendación</span>
                        <svg className="w-3.5 h-3.5 text-violet-400 ml-auto flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
                        </svg>
                      </div>
                    ) : (
                      <select className={`${base} bg-[#0f0f1a]`} value={form.howDidYouHear} onChange={e => upd('howDidYouHear', e.target.value)}>
                        <option value="">Selecciona...</option>
                        {['LinkedIn','Google','Recomendación','X/Twitter','Otro'].map(h => <option key={h} value={h}>{h}</option>)}
                      </select>
                    )}
                  </div>
                </div>
                <Nav onNext={next} />
              </div>
            )}

            {/* ── PASO 5 ── */}
            {step === 5 && (
              <div className="animate-fade-in">
                <div className="flex items-start gap-3 mb-6">
                  <StepIcon n={5} />
                  <div>
                    <h2 className="text-xl font-bold text-white">Audiencia y regiones</h2>
                    <p className="text-sm text-gray-400 mt-0.5">¿A qué mercados llegas con tu contenido o red?</p>
                  </div>
                </div>
                <div className="space-y-5">
                  <div>
                    <label className={lbl}>¿A qué regiones llega tu audiencia? * <span className="text-gray-500 font-normal">(selecciona varias)</span></label>
                    {errors.regions && <p className={errCls}>{errors.regions}</p>}
                    <div className="flex flex-wrap gap-2 mt-2">
                      {REGIONS.map(r => <Pill key={r} text={r} active={form.regions.includes(r)} onClick={() => toggle('regions', r)} />)}
                    </div>
                  </div>
                  <div>
                    <label className={lbl}>¿Has participado en otros programas de partners? *</label>
                    <select className={`${base} bg-[#0f0f1a]`} value={form.previousPrograms} onChange={e => upd('previousPrograms', e.target.value)}>
                      <option value="">Selecciona...</option>
                      <option value="active">Sí, actualmente activo en otros</option>
                      <option value="past">Sí, en el pasado</option>
                      <option value="first">No, este sería mi primero</option>
                    </select>
                    {errors.previousPrograms && <p className={errCls}>{errors.previousPrograms}</p>}
                  </div>
                </div>
                <Nav onNext={next} />
              </div>
            )}

            {/* ── PASO 6 ── */}
            {step === 6 && (
              <div className="animate-fade-in">
                <div className="flex items-start gap-3 mb-6">
                  <StepIcon n={6} />
                  <div>
                    <h2 className="text-xl font-bold text-white">Políticas y confirmación</h2>
                    <p className="text-sm text-gray-400 mt-0.5">Lee y acepta los términos para completar tu solicitud.</p>
                  </div>
                </div>
                <div className="space-y-4">
                  {([
                    { key: 'acceptedNoFraud' as const, text: 'Acepto no realizar auto-referidos, fraude, suplantación de identidad ni pujar por la marca "World Reach" en SEM sin autorización escrita.' },
                    { key: 'acceptedNoGuarantee' as const, text: 'Acepto no hacer afirmaciones de resultados garantizados al promover World Reach. SEO no tiene resultados garantizados.' },
                    { key: 'acceptedTerms' as const, text: 'He leído y acepto los Términos del Programa de Partners y la Política de Datos de World Reach.' },
                  ]).map(({ key, text }) => (
                    <div key={key}>
                      <label className="flex items-start gap-3 cursor-pointer group" onClick={() => upd(key, !form[key])}>
                        <div className="mt-0.5 flex-shrink-0">
                          <div className={`w-5 h-5 rounded border-2 flex items-center justify-center transition-all ${
                            form[key] ? 'bg-violet-600 border-violet-600' : 'bg-transparent border-white/20 group-hover:border-white/40'
                          }`}>
                            {form[key] && <IconCheck />}
                          </div>
                        </div>
                        <span className="text-sm text-gray-300 leading-relaxed">{text}</span>
                      </label>
                      {errors[key] && <p className={`${errCls} ml-8`}>{errors[key]}</p>}
                    </div>
                  ))}
                  {submitError && (
                    <div className="p-3 rounded-xl bg-red-500/10 border border-red-500/30 mt-2">
                      <p className="text-red-400 text-sm">{submitError}</p>
                    </div>
                  )}
                </div>
                <Nav onNext={submit} label="Enviar solicitud" isSubmit />
              </div>
            )}

          </div>
        </div>

        <p className="text-center text-sm text-gray-500 mt-6">
          ¿Ya tienes cuenta?{' '}
          <a href="/login" className="text-violet-400 hover:text-violet-300 transition-colors">Inicia sesión</a>
        </p>
      </div>
    </div>
  );
}
